import * as yup from 'yup'

const SchemaValidations = yup.object().shape({
  receiverEmail: yup.string().email('No es un correo válido')
})

export default SchemaValidations